var map = {
	"./about-home.jpg": 6288,
	"./about.jpg": 6476,
	"./activities/adventure-combo.jpg": 6944,
	"./activities/archery-tag.jpg": 7100,
	"./activities/bumper-ball-excitement.jpg": 9004,
	"./activities/enclosure-bay-lagoon-snorkeling-trail.jpg": 868,
	"./activities/guided-fat-wheel-electric-mountain-bike-trips.jpg": 4832,
	"./activities/half-day-sea-kayaking-guided-trips.jpg": 8120,
	"./activities/kayak-fishing-with-pro-boat-setup.jpg": 872,
	"./activities/rifle-with-scope.jpg": 4880,
	"./activities/sailing-classic-open-boat.jpg": 7363,
	"./activities/sea-kayaking-from-sunset-into-the-night.jpg": 8820,
	"./activities/self-guided-fat-wheel-electric-mountain-bike-trips.jpg": 9484,
	"./activities/single-stand-up-paddle-boards.jpg": 5692,
	"./activities/sit-on-top-kayak-hire.jpg": 7636,
	"./activities/target-combination-aadventure.jpg": 1188,
	"./activities/ten-man-stand-up-paddle-boards.jpg": 3640,
	"./activities/two-hour-sea-kayaking-guided-trips.jpg": 6284,
	"./activities/waiheke-themed-mini-golf.jpg": 2260,
	"./activities/windsurf-lessons.jpg": 5344,
	"./backgrounds/about-us.jpg": 8348,
	"./backgrounds/contact.jpg": 8244,
	"./backgrounds/home.jpg": 3132,
	"./backgrounds/land-activities.jpg": 1496,
	"./backgrounds/team-building.jpg": 6456,
	"./backgrounds/water-activities.jpg": 3676,
	"./gallery-home.jpg": 5532,
	"./gallery/beach-double-kayak.jpg": 7992,
	"./gallery/bike-forest.jpg": 2484,
	"./gallery/bike-lookout.jpg": 2064,
	"./gallery/bike-mudbrick.jpg": 1308,
	"./gallery/bike-on-beach.jpg": 2580,
	"./gallery/bike-stop.jpg": 9567,
	"./gallery/bike-tour-beach.jpg": 9812,
	"./gallery/bike-tour-view.jpg": 2572,
	"./gallery/bike-view.jpg": 5804,
	"./gallery/bike-vineyard.jpg": 8600,
	"./gallery/double-kayak-cave.jpg": 4944,
	"./gallery/double-kayak.jpg": 9108,
	"./gallery/four-man-sup.jpg": 2351,
	"./gallery/front-sit-on-top.jpg": 5524,
	"./gallery/kayak-beach.jpg": 84,
	"./gallery/kayak-bird-photo.jpg": 7984,
	"./gallery/kayak-cave-double.jpg": 3540,
	"./gallery/kayak-cave.jpg": 8748,
	"./gallery/kayak-cliffs.jpg": 3632,
	"./gallery/kayak-double-auckland.jpg": 4088,
	"./gallery/kayak-double-cave.jpg": 1300,
	"./gallery/kayak-double-cliff.jpg": 932,
	"./gallery/kayak-hole-in-rock.jpg": 7133,
	"./gallery/kayak-loading.jpg": 1752,
	"./gallery/kayak-mangrove-two.jpg": 3976,
	"./gallery/kayak-mangrove.jpg": 4204,
	"./gallery/kayak-paddles-up.jpg": 240,
	"./gallery/kayak-shallow.jpg": 2312,
	"./gallery/kayak-sit-on-top-beached.jpg": 8276,
	"./gallery/kayak-skull-rock.jpg": 5928,
	"./gallery/kayak-trees-on-hill.jpg": 5052,
	"./gallery/kayak-trip.jpg": 2048,
	"./gallery/kayak-two-doubles.jpg": 4004,
	"./gallery/kayak-van-trailer.jpg": 3648,
	"./gallery/kayak-with-dolphins.jpg": 1824,
	"./gallery/kayaks-in-the-bay.jpg": 3500,
	"./gallery/mini-golf-group.jpg": 7912,
	"./gallery/mini-golf.jpg": 9244,
	"./gallery/night-kayak.jpg": 6156,
	"./gallery/single-kayak-beach.jpg": 3120,
	"./gallery/single-kayak.jpg": 1620,
	"./gallery/sit-on-top-cave.jpg": 852,
	"./gallery/sit-on-top-double.jpg": 4408,
	"./gallery/sit-on-top-group.jpg": 6316,
	"./gallery/sit-on-top-hole.jpg": 6892,
	"./gallery/sit-on-top-kayaks.jpg": 6420,
	"./gallery/sit-on-top-land.jpg": 4588,
	"./gallery/sit-on-top-line.jpg": 9880,
	"./gallery/sit-on-top-looking.jpg": 2040,
	"./gallery/sit-on-top.jpg": 5924,
	"./gallery/standup-paddble-boards.jpg": 340,
	"./gallery/sup-group.jpg": 284,
	"./gallery/three-kayaks-beach.jpg": 1868,
	"./gallery/two-double-kayak.jpg": 2724,
	"./gallery/two-in-double.jpg": 948,
	"./gallery/two-kayaks-one-hand.jpg": 3335,
	"./gallery/windsurf.jpg": 9876,
	"./icon.png": 72,
	"./logo.jpg": 420,
	"./og-image.jpg": 4084,
	"./web-logo.jpg": 7796
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 748;